export default "__VITE_ASSET__D_J8Ebtv__"